import React from "react";
import { useTranslation } from "react-i18next";
import Strip from "../Strip";
import AllCompanies from "../AllCompanies";
import AllContacts from "../AllContacts";

export default function Companies() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col">
      <div className="py-12 px-6 md:px-12">
        <Strip>{t("home.structure")}</Strip>
        <AllCompanies />
      </div>
      <AllContacts />
    </div>
  );
}
